// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__DnK_Q","mainContent":"Card_mainContent__qU3tS"};